import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'components'

const EditCoverage = ({ handleEditClick, selectedPersons }) => {
  const editClick = (e) => {
    e.preventDefault()
    handleEditClick()
  }

  const nameOutput = selectedPersons
    .map((person) => {
      let name = person.FirstName
      name += person.Relationship === 'Employee' ? ' (me)' : ''
      return name
    })
    .join(', ')

  return (
    <div className="layout-section-stack">
      <p className="layout-muted-text">Show prices for:</p>
      <div className="layout-section-header">
        <span className="layout-section-title">{nameOutput}</span>
        <Button variant="primary" size="sm" type="button" onClick={editClick}>
          Edit
        </Button>
      </div>
    </div>
  )
}

EditCoverage.displayName = 'EditCoverage'
EditCoverage.propTypes = {
  handleEditClick: PropTypes.func.isRequired,
  selectedPersons: PropTypes.array.isRequired,
}

export default EditCoverage
